import { render } from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=template&id=515c581c&scoped=true"
import script from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"

import "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=style&index=0&id=515c581c&lang=scss"
import "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=style&index=1&id=515c581c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515c581c"]])

export default __exports__